import _ from "underscore";
import {isPresent} from "../../utilities/general";

export function applySessionCachingLogic(els) {
      els.searchCriteria.val(JSON.stringify(els.searchCriteriaHiddenInput));
      populateDateFilterDate(els);
      populateAdditionalFilterData(els);
}

function populateAdditionalFilterData(els) {
  if(isPresent(els.savedFilterCriteria)) {
    _.each(els.savedFilterCriteria, function(criteria){
      if(_.contains(els.additionalFilterkeyArr, criteria.key)) {
        _.each(criteria.value, function(value){
        	const currentCheckBox = $(document).find(`#${els.namespace}additional-filter-modal .filter-list a input[type="checkbox"][value="${value}"]`);
        	currentCheckBox.prop('checked', true); 
        	currentCheckBox.parent().addClass("additional-filter-selected");
        });
      }
    });
  }
}

function populateDateFilterDate(els) {
	/*
		for now we are clling filter.js function.
		we need refactor this.
	*/
	window.setCacheCustomDateRange(els.savedFilterCriteria, els.extraDetailForCache.selectedRangeType);
	window.setCacheFixDateRange(els.extraDetailForCache.selectedRangeType);
}



// WEBPACK FOOTER //
// ./src/pages/common/lookupSessionCaching.js